
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './service/auth.service';
import { DomainService } from '../domain/domain.service';

export const loginGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const domain = inject(DomainService);

  const slugParam = route.paramMap.get('slug') || '';
  const commParam = route.paramMap.get('communityId') || '';
  const url = state.url.toLowerCase();

  // For any community-scoped URL, eagerly hydrate storage from params
  if (domain.isCommunityDomain() && slugParam && commParam) {
    const storedSlug = localStorage.getItem('slug') || '';
    const storedCid  = localStorage.getItem('communityId') || '';
    if (storedSlug !== slugParam) localStorage.setItem('slug', slugParam);
    if (storedCid !== commParam)  localStorage.setItem('communityId', commParam);
  }

  const isCommunityPublic =
    domain.isCommunityDomain() && (
      /^\/[^\/]+\/[^\/]+\/login/.test(url) ||
      /^\/[^\/]+\/[^\/]+\/registration/.test(url) ||
      /^\/[^\/]+\/[^\/]+\/forgot-password/.test(url) ||
      /^\/[^\/]+\/[^\/]+\/reset-password/.test(url) ||
      /^\/[^\/]+$/.test(url)
    );

  if (isCommunityPublic) return true;

  // profile-domain behavior unchanged:
  if (!domain.isCommunityDomain() && !auth.isLoggedIn()) return true;
  if (!domain.isCommunityDomain() && auth.isLoggedIn()) {
    router.navigate(['/profile']);
    return false;
  }

  return !auth.isLoggedIn();
};
